import React from 'react';

import spinnerBackgroundPath from 'assets/photo/letter-number-formations/spinner/spinner-background.png';
import spinnerArrowsPath from 'assets/photo/letter-number-formations/spinner/spinner-arrows.png';

function Spinner(props) {
  return (
    <div className={`spinner ${props.show ? '' : 'hidden'}`}>
      <img alt='' src={spinnerBackgroundPath} />
      <img alt='' src={spinnerArrowsPath} />
    </div>
  );
}

export default Spinner;
